import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import api from '../utils/api'

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      login: async (email, password) => {
        set({ isLoading: true })
        try {
          const response = await api.post('/auth/login', { email, password })
          const { access_token, user } = response.data
          
          set({
            token: access_token,
            user,
            isAuthenticated: true,
            isLoading: false,
          })
          
          // Set token for future requests
          api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
          
          return { success: true }
        } catch (error) {
          set({ isLoading: false })
          return { 
            success: false, 
            error: error.response?.data?.detail || 'Login failed' 
          }
        }
      },

      register: async (email, password) => {
        set({ isLoading: true })
        try {
          const response = await api.post('/auth/register', { email, password })
          set({ isLoading: false })
          return { success: true, message: 'Registration successful. Please login.' }
        } catch (error) {
          set({ isLoading: false })
          return { 
            success: false, 
            error: error.response?.data?.detail || 'Registration failed' 
          }
        }
      },

      googleLogin: async (credential) => {
        set({ isLoading: true })
        try {
          // Send the Google JWT credential to the backend for verification
          const response = await api.post('/auth/google', { 
            credential: credential,
            client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID
          })
          
          const { access_token, user } = response.data
          
          set({
            token: access_token,
            user,
            isAuthenticated: true,
            isLoading: false,
          })
          
          // Set token for future requests
          api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
          
          return { success: true, user }
        } catch (error) {
          set({ isLoading: false })
          return { 
            success: false, 
            error: error.response?.data?.detail || error.message || 'Google login failed' 
          }
        }
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        })
        delete api.defaults.headers.common['Authorization']
      },

      initializeAuth: () => {
        const { token } = get()
        if (token) {
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`
          set({ isAuthenticated: true })
        }
      },
    }),
    {
      name: 't8r-auth-storage',
      partialize: (state) => ({ 
        token: state.token, 
        user: state.user, 
        isAuthenticated: state.isAuthenticated 
      }),
    }
  )
)

export default useAuthStore